import React from 'react'
import { useTranslation } from 'react-i18next'
import KibDivider from '@chewy/kib-divider-react'
import { NumberUtils } from '@pbt/pbt-ui-components'

import { useRefundDialog } from '../context/RefundDialogProvider'

import styles from './RefundDetails.module.scss'

export const RefundDetails = () => {
  const { t } = useTranslation(['Common', 'Dialogs'])
  const { refundInvoice } = useRefundDialog()
  const { originalInvoice } = refundInvoice
  const {
    subtotal = 0,
    additionalDiscount = 0,
    totalDiscount = 0,
    totalTax = 0,
  } = originalInvoice
  const discounts = additionalDiscount + totalDiscount
  const refundTotal = subtotal - discounts + totalTax

  return (
    <div className={styles.refundDetailsContainer}>
      <h4 className={styles.sectionTitle}>
        {t('Common:PAYMENTS.REFUND_DETAILS')}
      </h4>
      <div className={styles.row}>
        <div className={styles.rowItem}>
          {t('Dialogs:REFUND_DIALOG_V2.ORIGINAL_SUBTOTAL')}
        </div>
        <div className={styles.rowItem}>
          {NumberUtils.formatMoney(subtotal)}
        </div>
      </div>
      <div className={styles.row}>
        <div className={styles.rowItem}>{t('Common:DISCOUNTS')}</div>
        <div className={styles.rowItem}>
          {NumberUtils.formatMoney(discounts)}
        </div>
      </div>
      <div className={styles.row}>
        <div className={styles.rowItem}>{t('Common:TAX')}</div>
        <div className={styles.rowItem}>
          {NumberUtils.formatMoney(totalTax)}
        </div>
      </div>
      <KibDivider className={styles.refundDivider} color="alternate" />
      <div className={styles.row}>
        <div className={styles.rowItem}>
          {t('Dialogs:REFUND_DIALOG_V2.ORIGINAL_AMOUNT_PAID')}
        </div>
        <div className={styles.rowItem}>
          {NumberUtils.formatMoney(refundTotal)}
        </div>
      </div>
      {refundInvoice?.payments && refundInvoice?.payments?.length > 0 && (
        <>
          {refundInvoice?.payments?.map((payment) => {
            const { method, cardType, lastFour, amount, id } = payment
            const methodName = method?.name || ''
            const paymentMethodDisplay =
              cardType && lastFour
                ? `${t('Common:PAYMENTS.REFUNDED_TO')} ${cardType.name} ${lastFour}`
                : `${t('Common:PAYMENTS.REFUNDED_TO')} ${methodName}`

            return (
              <div className={styles.row} key={id}>
                <div className={styles.rowItem}>{paymentMethodDisplay}</div>
                <div className={styles.rowItem}>
                  ({NumberUtils.formatMoney(amount)})
                </div>
              </div>
            )
          })}
        </>
      )}
    </div>
  )
}
